import { render, staticRenderFns } from "./ReviewRatings.vue?vue&type=template&id=46a637cf&scoped=true&"
import script from "./ReviewRatings.vue?vue&type=script&lang=js&"
export * from "./ReviewRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a637cf",
  null
  
)

export default component.exports